/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/DecisionTopicCommentPaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./DecisionTopicCommentPaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.DecisionTopicReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.DecisionTopicCommentPaginationSlice);
  }
}(this, function(ApiClient, DecisionTopicCommentPaginationSlice) {
  'use strict';




  /**
   * The DecisionTopicReport model module.
   * @module model/DecisionTopicReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>DecisionTopicReport</code>.
   * @alias module:model/DecisionTopicReport
   * @class
   */
  var exports = function() {
    var _this = this;




















  };

  /**
   * Constructs a <code>DecisionTopicReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DecisionTopicReport} obj Optional instance to populate.
   * @return {module:model/DecisionTopicReport} The populated <code>DecisionTopicReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('AttachmentFileData')) {
        obj['AttachmentFileData'] = ApiClient.convertToType(data['AttachmentFileData'], 'String');
      }
      if (data.hasOwnProperty('Comments')) {
        obj['Comments'] = DecisionTopicCommentPaginationSlice.constructFromObject(data['Comments']);
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('CreatedBy')) {
        obj['CreatedBy'] = ApiClient.convertToType(data['CreatedBy'], 'Integer');
      }
      if (data.hasOwnProperty('TypeID')) {
        obj['TypeID'] = ApiClient.convertToType(data['TypeID'], 'Integer');
      }
      if (data.hasOwnProperty('PhaseID')) {
        obj['PhaseID'] = ApiClient.convertToType(data['PhaseID'], 'Integer');
      }
      if (data.hasOwnProperty('RequireDecision')) {
        obj['RequireDecision'] = ApiClient.convertToType(data['RequireDecision'], 'Boolean');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('FunctionID')) {
        obj['FunctionID'] = ApiClient.convertToType(data['FunctionID'], 'Integer');
      }
      if (data.hasOwnProperty('AttachmentFileIdentifier')) {
        obj['AttachmentFileIdentifier'] = ApiClient.convertToType(data['AttachmentFileIdentifier'], 'String');
      }
      if (data.hasOwnProperty('AttachmentFileName')) {
        obj['AttachmentFileName'] = ApiClient.convertToType(data['AttachmentFileName'], 'String');
      }
      if (data.hasOwnProperty('ExternalSourceLink')) {
        obj['ExternalSourceLink'] = ApiClient.convertToType(data['ExternalSourceLink'], 'String');
      }
      if (data.hasOwnProperty('MilestoneID')) {
        obj['MilestoneID'] = ApiClient.convertToType(data['MilestoneID'], 'Integer');
      }
      if (data.hasOwnProperty('StrategicGoalID')) {
        obj['StrategicGoalID'] = ApiClient.convertToType(data['StrategicGoalID'], 'Integer');
      }
      if (data.hasOwnProperty('StrategyDescriptionID')) {
        obj['StrategyDescriptionID'] = ApiClient.convertToType(data['StrategyDescriptionID'], 'Integer');
      }
      if (data.hasOwnProperty('Sort')) {
        obj['Sort'] = ApiClient.convertToType(data['Sort'], 'Integer');
      }
      if (data.hasOwnProperty('StatusID')) {
        obj['StatusID'] = ApiClient.convertToType(data['StatusID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} AttachmentFileData
   * @default ''
   */
  exports.prototype['AttachmentFileData'] = '';
  /**
   * @member {module:model/DecisionTopicCommentPaginationSlice} Comments
   */
  exports.prototype['Comments'] = undefined;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} CreatedBy
   * @default 0
   */
  exports.prototype['CreatedBy'] = 0;
  /**
   * @member {Integer} TypeID
   * @default 0
   */
  exports.prototype['TypeID'] = 0;
  /**
   * @member {Integer} PhaseID
   */
  exports.prototype['PhaseID'] = undefined;
  /**
   * @member {Boolean} RequireDecision
   * @default false
   */
  exports.prototype['RequireDecision'] = false;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {Integer} FunctionID
   * @default 0
   */
  exports.prototype['FunctionID'] = 0;
  /**
   * @member {String} AttachmentFileIdentifier
   * @default ''
   */
  exports.prototype['AttachmentFileIdentifier'] = '';
  /**
   * @member {String} AttachmentFileName
   * @default ''
   */
  exports.prototype['AttachmentFileName'] = '';
  /**
   * @member {String} ExternalSourceLink
   * @default ''
   */
  exports.prototype['ExternalSourceLink'] = '';
  /**
   * @member {Integer} MilestoneID
   */
  exports.prototype['MilestoneID'] = undefined;
  /**
   * @member {Integer} StrategicGoalID
   */
  exports.prototype['StrategicGoalID'] = undefined;
  /**
   * @member {Integer} StrategyDescriptionID
   */
  exports.prototype['StrategyDescriptionID'] = undefined;
  /**
   * @member {Integer} Sort
   * @default 0
   */
  exports.prototype['Sort'] = 0;
  /**
   * @member {Integer} StatusID
   * @default 0
   */
  exports.prototype['StatusID'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


